import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-view-unita-locali',
  templateUrl: './view-unita-locali.component.html',
  styleUrls: ['./view-unita-locali.component.css']
})
export class ViewUnitaLocaliComponent implements OnInit,AfterViewInit {

  constructor(private userComponentService:ComponentService,) {

  }
  clikka(e):void{
   e.preventDefault();
   let tabsJson =[
    {
      id: 599,
      title: 'Dati ULLLL222222',
      icon: 'user',
      component:'ViewDatigeneraliSedeComponent',
      //data:e

    }
  ];
  this.userComponentService.addNewTab("tabs1",tabsJson);

  }
  ngAfterViewInit(): void {


  }
  ngOnInit() {
    let tabsJson =[
      {
        id: 5,
        title: 'Dati ULLLL',
        icon: 'user',
        component:'ViewDatigeneraliSedeComponent',
        //data:e

      }
    ];
    this.userComponentService.setTabs("tabs2",tabsJson);





  }

}
